module.exports = __webpack_public_path__ + "img/20180815_145911_031.a703d8f9.jpg";